import React, { useEffect, useState } from "react";
import { ModalContainer } from "../partials/modalbackground";
import { Icon } from "@iconify/react";
import PrimaryBtn from "../partials/btn";
import { Controller, useForm } from "react-hook-form";
import { apiCall, useApiCall } from "../../data/useFetcher";
import { useUsersStore } from "../../data/stores/loggerStore";
import { InputWithIcon } from "../partials/inputs";
import useAuthStore from "../../data/stores/authStore";

interface FormType {
  email: string;
  departmentName: string;
  erpModule: string;
}

const InviteModal = ({ handleModal, handleClose }) => {
  const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({
      defaultValues: {
        departmentName: "",
        email: "",
        erpModule: "",
      },
    }),
    { onSubmitAPI, loading } = useApiCall(),
    { getDynamicLogger } = useUsersStore(),
    { user } = useAuthStore();
  const onSubmit = async (data: FormType) => {
    await onSubmitAPI({
      url: `/api/v1/auth/user/manage-users/manage-team-members`,
      type: "post",
      data: { members: [data] },
      toggleModal: () => {
        handleModal();
        apiCall({
          type: "get",
          url: `/api/v1/auth/user/manage-users?privilege=focal person&organization=${user?._id}`,
          getter: (d: any) => getDynamicLogger(d, "allDataFocalPerson"),
        });
      },
    });
  };

  return (
    <div>
      <ModalContainer>
        <div className="bg-white modal-shadow w-[400px] rounded-xl p-6">
          <div
            style={{
              border: "8px solid #E6F3FE",
            }}
            className="size-12 rounded-full flex justify-center items-center bg-[#E6F3FE]"
          >
            <Icon
              icon={"mingcute:user-add-line"}
              color="#2070B8"
              style={{
                fontSize: "24px",
              }}
            />
          </div>
          <h4 className="text-lg my-3 font-medium text-sec">
            Invite Department
          </h4>
          <p className="text-sm font-normal text-[#667085]">
            Enter details correctly.{" "}
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className="mt-5">
            <div className="space-y-4">
              <div>
                <Controller
                  name="departmentName"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  render={({ field: { value, onChange, name } }) => (
                    <InputWithIcon
                      icon="la:user"
                      placeholder="Enter Department"
                      label="Department*"
                      value={value}
                      onChange={onChange}
                      name={name}
                    />
                  )}
                />
                {errors.departmentName && (
                  <p className="text-[#dc2626] text-xs mt-4">
                    {errors.departmentName.message}
                  </p>
                )}
              </div>
              <div>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "This field is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email format",
                    },
                  }}
                  render={({ field: { value, onChange, name } }) => (
                    <InputWithIcon
                      icon="mdi-light:email"
                      placeholder="Enter Email"
                      label="Focal Person*"
                      type="email"
                      value={value}
                      onChange={onChange}
                      name={name}
                    />
                  )}
                />
                {errors.email && (
                  <p className="text-[#dc2626] text-xs mt-3">
                    {errors.email.message}
                  </p>
                )}
              </div>
              <div>
                <Controller
                  name="erpModule"
                  control={control}
                  rules={{
                    required: "ERP Module is required",
                  }}
                  render={({ field: { value, onChange, name } }) => (
                    <InputWithIcon
                      icon="mdi:database-outline"
                      placeholder="Enter Module"
                      label="ERP Modules / Data Systems Used*"
                      value={value}
                      onChange={onChange}
                      name={name}
                    />
                  )}
                />
                {errors.erpModule && (
                  <p className="text-[#dc2626] text-xs mt-4">
                    {errors.erpModule.message}
                  </p>
                )}
              </div>
            </div>
            <div className="mt-8  gap-4 items-center w-full grid grid-cols-2">
              <button
                onClick={handleClose}
                type="button"
                className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
                "
              >
                Cancel
              </button>
              <PrimaryBtn
                text="Send Invite"
                width="w-full"
                type="submit"
                loading={!!loading}
              />
            </div>
          </form>
        </div>
      </ModalContainer>
    </div>
  );
};

export default InviteModal;
